import { useState } from "react";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import { makeStyles } from '@mui/styles';
import * as yup from "yup";

const schema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
  name: yup.string().required("Name required"),
  message: yup.string().required("Message required")
});

const useStyles = makeStyles((theme) => ({
  margin: {
    margin: theme.spacing(2),
  },
  filled: {
    backgroundColor: "#1976d2",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#115293",
    },
  },
}));

export default function ContactForm() {
  const classes = useStyles();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    company: "", // honeypot
  });

  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const buttonStyles = {
    padding: "20px 60px",
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "20px",
    letterSpacing: "0.05em"
  };

  function handleChange(e) {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setErrors((prev) => ({ ...prev, [e.target.name]: "" }));
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (formData.company) return; // honeypot

    try {
      await schema.validate(formData, { abortEarly: false });
      setErrors({});
    } catch (validationError) {
      const newErrors = {};
      validationError.inner.forEach(err => {
        newErrors[err.path] = err.message;
      });
      setErrors(newErrors);
      return;
    }

    setStatus("sending");

    try {
      const data = new FormData();
      data.append("access_key", "09796513-dcd8-4d75-8b4a-ee17c4af1d0e");
      data.append("name", formData.name);
      data.append("email", formData.email);
      data.append("message", formData.message);
      data.append("subject", "Jigpaws.com – Customer Service Notification");

      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: data
      });

      const result = await res.json();
      if (result.success) {
        setStatus("success");
        setFormData({ name: "", email: "", message: "", company: "" });
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  }

  // --- render ---
  return (
    <Box component="div">
      {status === "success" ? (
          <Box mt={2}>
            {/*<Alert severity="success">Message sent!</Alert>*/}
            <div className="contactFormWrapper">
              <div className="contactFormThanks">
                <body>
                Thank you for your message!<br/><br/>
                A member of our team will get back to you within 24 hours (often sooner).
                </body>
              </div></div>
          </Box>
        ) : (
        <Box component="form" onSubmit={handleSubmit}>
          <div className="formBox">
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField
                  name="name"
                  label="Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  error={!!errors.name}
                  helperText={errors.name}
                  variant="filled"
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  name="email"
                  label="Email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  error={!!errors.email}
                  helperText={errors.email}
                  variant="filled"
                  fullWidth
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  name="message"
                  label="Message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  multiline
                  rows={5}
                  error={!!errors.message}
                  helperText={errors.message}
                  variant="filled"
                  className="cleanMessage"
                  fullWidth
                />
              </Grid>
            </Grid>
          </div>

          <div className="formContainerWhite">
            <Button
              type="submit"
              variant="contained"
              size="large"
              className={`${classes.margin} filled`}
              sx={{ mt: 2, ...buttonStyles }}
              disabled={status === "sending"}
            >
              {status === "sending" ? "Sending..." : "Send"}
            </Button>
          </div>

          {status === "error" && (
            <Box mt={2}>
              <div className="error">Oops — something went wrong.<br/>
Please try again, or email support@jigpaws.com</div>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
}